import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Disclaimer from '../Disclaimer';
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next';
import { view09ImageOptions } from './views/view09'


class Deckplan extends Component {
    constructor(props) {
		super(props);
		this.handleBiminiOptionsChange = this.handleBiminiOptionsChange.bind(this);
	}

	handleBiminiOptionsChange(newValue) {
		let configuration = this.props.configuration;
		configuration.BiminiColor = newValue;

		if (this.props.onChange) {
			this.props.onChange(configuration);
		}
	}



    render() {
		let imageOptions = view09ImageOptions;



        let image = (
                <ConfiguratorImage boat="Xpower" configuration={this.props.configuration} options={imageOptions} />
        );


		
        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>

					<h1><Trans defaults='Deckplan & Bimini' /></h1>
					<p><Trans defaults='The space on board the X-Power 33C is not only designed to be functional and safe while at sea but has also to create a luxurious outdoor living space - in the cockpit as well as on the front deck. The X-Power 33C has an optional T-Top, creating the perfect protection from sun and wind together with the standard windscreen. Bimini and cockpit tent are optional.' /></p>


					{this.props.configuration.TTop.value !== 3 ? null : <React.Fragment>
						<h2><Trans defaults='Bimini' /></h2>
						<MaterialSelector options={this.props.BiminiOptions} label={this.props.configuration.BiminiColor.label} value={this.props.configuration.BiminiOptions} onChange={this.handleBiminiOptionsChange} />
						<Disclaimer />
					</React.Fragment>}

					<Disclaimer />
				</ConfiguratorOption>
			</ConfiguratorSection>
		);

		
		
    }
}

export default withTranslation()(Deckplan);


// WEBPACK FOOTER //
// ./src/Xpower/Deckplan.js